import {PackingSlip} from '../../types/packingSlipStatusResponse';

const filterCanceledPackingSlips = (packingSlip: PackingSlip): boolean => {
    return (
        packingSlip.shipment.state !== 'canceled' &&
        packingSlip.items.filter(item => item.state !== 'canceled').length > 0
    );
};

export default filterCanceledPackingSlips;
